import { render, staticRenderFns } from "./tratamientos.vue?vue&type=template&id=02157962&scoped=true"
import script from "./tratamientos.vue?vue&type=script&lang=js"
export * from "./tratamientos.vue?vue&type=script&lang=js"
import style0 from "./tratamientos.vue?vue&type=style&index=0&id=02157962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02157962",
  null
  
)

export default component.exports